import { AuthService as authService } from '@common/auth.service';

class LoginDialogController implements angular.IOnInit {
  public username: string;
  public password: string;

  public isLoading: boolean;
  public loginFailed: boolean = false;

  /** @ngInject */
  constructor(private authService: authService, private $mdDialog: angular.material.IDialogService) { }

  $onInit(): void {
    this.isLoading = false;
  }

  login = () => {
    if (this.username != undefined) {
      this.isLoading = true;
      this.loginFailed = false;
      this.username = this.username.toLowerCase();
      this.authService.login(this.username, this.password, true)
        .then(
          (response) => this.$mdDialog.hide(true),
          (errResp) => { this.loginFailed = true; }
        ).finally(() => this.isLoading = false);
    }
  }
}

export const loginDialog: angular.IComponentOptions = {
  template: require('./login.dialog.html'),
  controller: LoginDialogController
}



// WEBPACK FOOTER //
// ./src/app/login/login-dialog/login-dialog.ts